import React, { useCallback } from 'react'
import { styled } from '@mui/material'
import { useSnapshot } from 'valtio'
import {
  getFeedbackItemsFromPercentages,
  getPercentagesPadLength,
  percentageFormatter,
  useItemResponsePercentages,
} from '@app/helpers'
import { ScoringState } from '@app/storage'
import { ItemFeedbackGroup } from './ItemFeedbackGroup'

const StyledFeedback = styled(ItemFeedbackGroup, {
  shouldForwardProp: prop => prop !== 'theme',
})(({ theme }) => ({
  marginTop: theme.spacing(4),
}))

type Props = {
  itemId: string
}

export const QuestionGroupFeedback: React.FC<Props> = ({ itemId }) => {
  const { isPreviewMode } = useSnapshot(ScoringState)
  const percentages = useItemResponsePercentages(itemId)

  const padLength = getPercentagesPadLength(percentages)

  const feedbackPercentageFormatter = useCallback(
    (percentage: number) => percentageFormatter.format(percentage).padStart(padLength, ' '),
    [padLength],
  )

  // In preview mode, don't show the feedback boxes at all
  if (!percentages || isPreviewMode) {
    return null
  }

  const feedbackItems = getFeedbackItemsFromPercentages(percentages)

  return (
    <StyledFeedback
      items={feedbackItems}
      percentageFormatter={feedbackPercentageFormatter}
      hidePercentages={isPreviewMode}
    />
  )
}
